module.exports = __webpack_public_path__ + "img/53-l.d1d31f99.png";